// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { StyleProps as CheckboxStyleProps } from "@insite/mobius/Checkbox/Checkbox";

import { productListFilterAccordionSectionStyles } from "@steiner/Overrides/Widgets/ProductList/ProductListFilterAccordionSection";
import Minus from "@steiner/XDL/Icons/Minus";
import Plus from "@steiner/XDL/Icons/Plus";
import Search from "@steiner/XDL/Icons/Search";
import { fontConfig } from "@steiner/XDL/PreStyle/typography";
import { color, styledScrollbar } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

productListFilterAccordionSectionStyles.accordionSection = {
    panelProps: {
        css: css`
            border: none;
            padding: 6px 9px 8px;
        `,
    },
    titleTypographyProps: {
        size: fontConfig.fontSize.xSmall,
        lineHeight: fontConfig.lineHeight.xSmall,
    },
    headerProps: {
        css: css`
            border-top: 1px solid ${color("common.border")};
            &&& button,
            &&& button:focus {
                margin-bottom: 0;
                padding: 8px 8px 4px;
                border: none;
            }
        `,
    },
};

productListFilterAccordionSectionStyles.checkBox = {
    css: css<CheckboxStyleProps>`
        align-items: flex-start;
        width: 100%;
        span[role="checkbox"] {
            ${({ _sizeVariant }) =>
                _sizeVariant === "small"
                    ? css`
                          margin-top: 5px;
                      `
                    : css`
                          margin-top: 2px;
                      `}
        }
    `,
    typographyProps: {
        css: css`
            word-break: break-word;
            display: flex;
            width: 100%;
            line-height: ${fontConfig.lineHeight.xSmall};
        `,
    },
};

productListFilterAccordionSectionStyles.facetCount = {
    color: "text.main",
    css: css`
        margin: 0 9px 0 auto;
        padding-left: 2px;
        flex-shrink: 0;
    `,
};

productListFilterAccordionSectionStyles.seeAllLink = {
    mergeCss: true,
    icon: {
        iconProps: {
            src: Plus,
            size: 12,
            css: css`
                opacity: 0.66;
            `,
        },
    },
    typographyProps: {
        size: fontConfig.fontSize.xSmall,
        lineHeight: fontConfig.lineHeight.xSmall,
    },
    css: css`
        margin-top: 6px;
    `,
};

productListFilterAccordionSectionStyles.seeLessLink = {
    mergeCss: true,
    icon: {
        iconProps: {
            src: Minus,
            size: 12,
            css: css`
                opacity: 0.66;
            `,
        },
    },
    typographyProps: {
        size: fontConfig.fontSize.xSmall,
        lineHeight: fontConfig.lineHeight.xSmall,
    },
    css: css`
        margin-top: 6px;
    `,
};

productListFilterAccordionSectionStyles.scrollableContainer = {
    css: css`
        ${({ scrollable, limitNumber }: any) =>
            scrollable &&
            css`
                max-height: calc(${limitNumber * 52}px - 8px);
                ${styledScrollbar()};
            `}
        display: flex;
        flex-direction: column;
    `,
};
